import React, { useState, useEffect } from "react";
import { json_ar } from "../jsonworks.js";
import {
  Link,
  // etc.
} from "react-router-dom";

function WorksYiz(props) {
  const [style, setStyle] = useState({ display: "none" });

  console.log(json_ar);
  return (
    <div className="container-fluid pt-5">
      <div className="row  d-flex justify-content-center  ">
        <h2 id="workid" className="text-center">
          My Portfolio
        </h2>

        {/* <div id="workid" className="text-center  col-10   shadow m-2 workid d-flex justify-content-center  " style={{}}>
         
          <div className="d-flex jusify-content-between align-items-end m-1 p-1">
                  
                    <button className="btn text-secondary  m-1">View Web</button>
                  
                  
                    <button className="btn  m-1 text-secondary ">View Code</button>
                
                    <button className="btn  m-1 text-secondary ">View  Server side Code</button>
                
                </div>
               
          </div> */}

        <div
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
          data-aos-delay="100"
          className="col-lg-10   shadow m-2 workid  d-flex "
          // style={{  
          //   backgroundImage: "url(" + "https://images.pexels.com/photos/2954405/pexels-photo-2954405.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" + ")",
          //   backgroundPosition: 'center',
          //   backgroundSize: 'cover',
          //   backgroundRepeat: 'no-repeat'
          // }}
        >
          <img src="cover2.jpg" className="p-3 " height="" />
          <div className="p-5">
            <h2 className=" h1 text-danger">Big Project</h2>

            <div className="">Huge project with server side use nodejs   real shop like ebay </div>

            <div className="d-flex jusify-content-between m-1 p-1">
              <a href="https://shop2yiz.netlify.app/">
                <button className="btn btn-warning  m-1">View Web</button>
              </a>
              <a href="https://github.com/yizfar/BigHugeClient_Side-shop-">
                <button className="btn btn-warning m-1  ">View Code</button>
              </a>
           
            </div>
               
            <a id="" className="" href="https://github.com/yizfar/BigHugeServer-Side">
                <button className="btn btn-warning m-1  ">
                  View server Code
                </button>
              </a>
          </div>
        </div>

        {json_ar.map((item) => {

          return (
            <div  key={item.name}
              data-aos="flip-up"
              data-aos-delay={item.aos}
              className="col-md-5   shadow m-2 workid  d-flex "
            >
              <img src={item.image} className=" " height="" />
              <div className="p-2">
                <h5 className=" ">{item.name} </h5>

                <div className="">{item.descrption} </div>

                <div className="d-flex jusify-content-center m-1 p-1">
                  <a href={item.netifly}>
                    <button className="btn btn-warning  m-1">View Web</button>
                  </a>
                  <a href={item.git}>
                    <button className="btn btn-warning m-1  ">View Code</button>
                  </a>
                </div>
              </div>
            </div>
          );
        })}

        {/* 
{json_ar.map(item => {
 return (
<div className="col-5   shadow m-2 workid"   onMouseEnter={e => {
                     setStyle({display: 'block'});
                 }}
                 onMouseLeave={e => {
                     setStyle({display: 'none'})
                 }}><img src={item.image} className="  me-2 float-start p-3"   />
                   <h2>{item.name}</h2>
          <div>{item.descrption}</div>
          <div>Money: {}</div>
          <div className="d-flex jusify-content-between p-4" >
           <button className="btn btn-warning m-2" style={style}>View Web </button>
           <button className="btn btn-warning m-2 " style={style}>View Code</button>
           </div>
            </div>
 )
})} */}

        {/* <div className="col-5   shadow m-2 workid" style={{backgroundImage:"codeimg.jpeg"}}   onMouseEnter={e => {
                     setStyle({display: 'block'});
                 }}
                 onMouseLeave={e => {
                     setStyle({display: 'none'})
                 }}><img src="img2.jpeg" className="  w-50 me-2 float-start p-3" height="240px"   />
                   <h2>work1</h2>
          <div>Company: {}</div>
          <div>Money: {}</div>
          <div className="d-flex jusify-content-between p-4" >
           <button className="btn btn-warning m-2" style={style}>View Web </button>
           <button className="btn btn-warning m-2 " style={style}>View Code</button>
           </div>
            </div>
       
        <div className="col-5  shadow m-2 workid"><img src="img2.jpeg" className="  w-50 me-2 float-start p-3" height="240px" /><span></span>
          <h2>work1</h2>
          <div>Company: {}</div>
          <div>Money: {}</div>
          <a className="btn btn-warning m-2">Web Link</a>
          <a className="btn btn-warning m-2">Code Link</a></div>
        <div className="col-5  shadow m-2 workid" style={{backgroundImage:"url(codeimg.jpeg)"}}><img src="img2.jpeg" className="  w-50 me-2 float-start p-3" height="240px" /><span></span>
          <h2>work1</h2>
          <div>Company: {}</div>
          <div>Money: {}</div>
          <a className="btn btn-warning m-2">Web Link</a>
          <a className="btn btn-warning m-2">Code Link</a></div>
        <div className="col-5  shadow m-2 workid"><img src="img2.jpeg" className="   float-start p-3" height="260px" /><span></span>
          <h2>work1</h2>
          <div>Company: {}</div>
          <div>Money: {}</div>
         
          <a className="btn btn-warning m-2">Web Link</a>
          <a className="btn btn-warning m-2">Code Link</a></div> */}
      </div>
    </div>
  );
}

export default WorksYiz;
